// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Stress Gauge Styles */

.stress-gauge {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  align-items: center;
  min-width: 150px;
}

.stress-gauge__header {
  display: flex;
  align-items: center;
  width: 100%;
}

.stress-gauge__container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.stress-gauge__circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.stress-gauge__inner-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
  display: flex;
  justify-content: center;
  align-items: center;
}

.stress-gauge__label {
  display: flex;
  align-items: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/StressGauge.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Stress Gauge Styles */\n\n.stress-gauge {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  align-items: center;\n  min-width: 150px;\n}\n\n.stress-gauge__header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.stress-gauge__container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.stress-gauge__circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.stress-gauge__inner-circle {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: var(--color-grey-100);\n  background-color: var(--color-grey-100);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.stress-gauge__label {\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
